export default __webpack_public_path__ + "static/media/Stalker's Belt of Shattered Souls.32f59457.jpg";